export const getXApiKeyHeader = () => process.env.REACT_APP_API_KEY as string;
